import { Injectable } from "@angular/core";
import { TabVerifier } from "./tab-verifier.service";

@Injectable({
  providedIn: 'root'
})
export class WildberriesTabVerifier extends TabVerifier {

  isProduct() {
    const match = /\/catalog\/[0-9]+\/detail\.aspx/g;
    return match.test(this.url.pathname);
  }

}
